<p-inputgroup>
  <p-iftalabel>
    <label>{{ label | transloco }}</label>
    <input
      type="text"
      pInputText
      readonly
      class="cursor-pointer"
      [value]="mother?.name || ''"
      (click)="openDialog()"
      spellcheck="false"
      autocomplete="off"
    />
    <p-button
      icon="pi pi-search"
      styleClass="p-button-text p-button-sm"
      (click)="openDialog()"
    />
  </p-iftalabel>
</p-inputgroup>

<p-dialog
  [(visible)]="dialogVisible"
  [style]="{ width: '90vw', height: '90vh' }"
  [modal]="true"
  [blockScroll]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="dialogVisible = false"
>
  <ng-template pTemplate="closeicon">
    <span class="closeicon pi pi-times"></span>
  </ng-template>
  <ng-template pTemplate="header">
    <div class="flex items-center mb-3">
      <div class="flex px-4 animal-name-headline">
        {{ label | transloco }}
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <div class="flex flex-row w-full justify-center mb-2">
      <input
        type="text"
        class="w-full"
        pInputText
        [(ngModel)]="searchTerm"
        [ngModelOptions]="{ standalone: true }"
        placeholder="{{ 'animalAdd.general.basicData.searchMother' | transloco }}"
        spellcheck="false"
        autocomplete="off"
        (input)="onSearch()"
      />
    </div>
    <div class="flex-grow-scroll">
      @if (animalSearchResult.length > 0) {
        <p-table [value]="animalSearchResult" class="p-mt-4">
          <ng-template pTemplate="header">
            <tr>
              <th></th>
              <th>{{ 'animalAdd.general.basicData.name' | transloco }}</th>
              <th>{{ 'animalAdd.general.basicData.type' | transloco }}</th>
              <th>{{ 'animalAdd.general.basicData.bookNumber' | transloco }}</th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-animal>
            <tr>
              <td class="relative">
                <app-animal-image-container [animal]="animal" [preview]="true" />
              </td>
              <td>{{ animal.name }}</td>
              <td>{{ animal.type }}</td>
              <td>{{ animal.bookNumber }}</td>
              <td class="flex flex-row-reverse">
                <p-button (click)="selectAnimal(animal)">
                  {{ 'animalAdd.general.basicData.addMother' | transloco }}
                </p-button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      }
    </div>
  </ng-template>
</p-dialog>
